import { render } from "./CxAlert.vue?vue&type=template&id=1ab164f4"
import script from "./CxAlert.vue?vue&type=script&lang=js"
export * from "./CxAlert.vue?vue&type=script&lang=js"

import "./CxAlert.vue?vue&type=style&index=0&id=1ab164f4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__